// --- Vendors ---
import Isotope from 'isotope-layout';
import jQueryBridget from 'jquery-bridget';
import imagesLoaded from 'imagesloaded'; // Importe imagesLoaded

// --- Components ---
const listing = {
    $grid: null,

    readyFn: function () {
        jQueryBridget('isotope', Isotope, $);

        const $grid = $('.grid-image');
        if (!$grid.length) {
            return;
        }

        // 1. On initialise Isotope tout de suite
        this.$grid = $grid.isotope({
            itemSelector: '.grid-item',
            percentPosition: true,
            masonry: {
                columnWidth: '.grid-item'
            }
        });

        // 2. On attend que TOUTES les images de la grille soient chargées 
        // pour relancer un layout propre.
        imagesLoaded($grid[0], () => {
            this.layout();
        });
    },

    layout: function () {
        if (!this.$grid) {
            return;
        }

        this.$grid.isotope('layout');
    }
};

export { listing };